'use strict';

/**
 * Component for the enum values
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-enum.hbs');

var EnumComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        enumDisplayStyle: function() {
            return this.enumDisplayStyle;
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function() {
        var field = this.getOption('field');
        this.enumDisplayStyle = field.editOptions.enumDisplayStyle;

        if (this.enumDisplayStyle !== 'radio' && this.enumDisplayStyle !== 'select') {
            this.enumDisplayStyle = field.options.enumValues.length < 5 ? 'radio' : 'select';
        }
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        var field = this.getOption('field');

        this.switchEnumValue(this.model.get(field.name));
    },

    onShow: function() {
        this.reset();
    },

    switchEnumValue: function(value) {
        var field = this.getOption('field');

        this.$('[name="' + field.name + '"][value="' + value + '"]').prop('checked', true);
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        if (this.enumDisplayStyle === 'radio') {
            data[field.name] = this.$('[name="' + field.name + '"]:checked').val();
        } else {
            data[field.name] = this.$('[name="' + field.name + '"]').val();
        }

        return data;
    },
});

module.exports = EnumComponent;